// Packages and components
import React from 'react';
import { Box } from 'grommet';

// Helpers and utlities
import { edgeSize, borderRadiusSize } from '@theme/globals/sizing';

// Types
import { SHDCalloutProps } from './SHDCallout.d';

const SHDCallout: React.FC<SHDCalloutProps> = ({
  children,
  background = 'gray-50',
  pad = 'small',
  round = 'small',
}) => {
  return (
    <Box
      background={background}
      direction="row"
      round={borderRadiusSize[round]}
      pad={edgeSize[pad]}
    >
      {children}
    </Box>
  );
};

export default SHDCallout;
